import { NEXUS_API_URL } from "@/environments";
import { NexusEcommerce } from "@/types/nexus-product";

export type DisabledVariant = {
  id: string;
  ecommerceId: string;
  productId: string;
  variantId: string;
  vendureOptionGroup: string;
  vendureOption: string;
  createdAt: string;
};

export async function getEcommerceByDomainClient(domain: string): Promise<NexusEcommerce> {
  const baseUrl = NEXUS_API_URL;
  if (!baseUrl) throw new Error("NEXUS_APP_URL is missing");

  const url = `${baseUrl.replace(/\/$/, "")}/public/ecommerce/by-domain/${domain}`;
  const res = await fetch(url);

  if (!res.ok) {
    throw new Error(
      `Failed to fetch ecommerce by domain (${res.status}) for ${domain}`,
    );
  }

  return res.json();
}
